export enum MainPage {
  Index = 'index',
  Referral = 'ref',
  Points = 'points',
  Markets = 'markets',
  Predictions = 'predictions',
  Portfolio = 'portfolio',
  Announcements = 'announcements',
  Maintenance = 'maintenance',
}

export enum TradePage {
  Trade = 'trade'
}

export enum TradeSubPage {
  Market = 'market-market',
  Trade = 'trade-slug',
  Derivatives = 'derivatives-derivative'
}
